const ASSESSMENT_ROUTE =
  /^\/projects\/[^/]+\/(?:anonymous-)?assessments\/[^/]+(?:\/|$)/i;

export const isAssessmentPageUrl = (url: string) => {
  const pathname = url.split(/[?#]/)[0];
  return ASSESSMENT_ROUTE.test(pathname);
};

export const resetPageScrollPosition = () => {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  window.scrollTo({ top: 0, left: 0, behavior: 'auto' });

  // Cover standards and quirks scrolling modes as well as older browsers.
  if (document.scrollingElement) {
    document.scrollingElement.scrollTop = 0;
    document.scrollingElement.scrollLeft = 0;
  }
  document.documentElement.scrollTop = 0;
  document.documentElement.scrollLeft = 0;
  document.body.scrollTop = 0;
  document.body.scrollLeft = 0;
};

export const prepareForPageTopNavigation = () => {
  if (typeof document === 'undefined') return;

  // React can reuse the clicked Next/Back button after replacing a long page.
  // Removing focus prevents the browser from scrolling to keep that button in view.
  const activeElement = document.activeElement;
  if (activeElement instanceof HTMLElement) activeElement.blur();

  resetPageScrollPosition();
};

/**
 * Repeat the reset through the next paint and the following layout pass. This
 * prevents router restoration and late question rendering from restoring the
 * previous page's scroll offset.
 */
export const schedulePageTopReset = () => {
  if (typeof window === 'undefined') return () => undefined;

  resetPageScrollPosition();

  let secondFrame = 0;
  const firstFrame = window.requestAnimationFrame(() => {
    resetPageScrollPosition();
    secondFrame = window.requestAnimationFrame(resetPageScrollPosition);
  });
  const afterLayout = window.setTimeout(resetPageScrollPosition, 100);

  return () => {
    window.cancelAnimationFrame(firstFrame);
    if (secondFrame) window.cancelAnimationFrame(secondFrame);
    window.clearTimeout(afterLayout);
  };
};
